module.exports = __webpack_public_path__ + "static/media/eg.80e40b36.jpeg";